import { AnalysisStatus } from '../../../models/general/analysis';

export type AnalysisProgressStatus =
  | 'WAITING'
  | 'PROCESSING'
  | 'FINISHED'
  | 'COMPLETED'
  | 'ERROR'
  | 'CANCELED'
  | 'SAVE_ERROR';

export interface AnalysisProgressData {
  id: number;
  status: AnalysisProgressStatus;
  progress?: number;
  message?: string;
  remaining?: string;
  elapsed?: number;
  ended_at?: string;
  error_message?: string;
  is_fully_completed?: boolean;
}

export type AnalysisWsMessageType =
  | 'analysis_waiting'
  | 'analysis_started'
  | 'analysis_progress_update'
  | 'analysis_finished'
  | 'analysis_error'
  | 'analysis_canceled'
  | 'analysis_persistence_completed';

export interface AnalysisWsMessage {
  type: AnalysisWsMessageType;
  data: {
    id: number;
    status?: AnalysisStatus;
    progress?: number;
    message?: string;
    remaining?: string;
    elapsed?: number;
    ended_at?: string;
    error_message?: string;
    is_fully_completed?: boolean;
  };
}

export const ANALYSIS_TERMINAL_STATUSES: AnalysisProgressStatus[] = [
  'FINISHED',
  'COMPLETED',
  'ERROR',
  'CANCELED',
  'SAVE_ERROR',
];

export const STORAGE_STATUS_TO_ENUM: Record<AnalysisProgressStatus, AnalysisStatus> = {
  WAITING: AnalysisStatus.WAITING,
  PROCESSING: AnalysisStatus.PROCESSING,
  FINISHED: AnalysisStatus.COMPLETED,
  COMPLETED: AnalysisStatus.COMPLETED,
  ERROR: AnalysisStatus.ERROR,
  CANCELED: AnalysisStatus.CANCELED,
  SAVE_ERROR: AnalysisStatus.SAVE_ERROR,
};

export const BACKEND_STATUS_TO_PROGRESS: Partial<Record<AnalysisStatus, AnalysisProgressStatus>> = {
  [AnalysisStatus.WAITING]: 'WAITING',
  [AnalysisStatus.PROCESSING]: 'PROCESSING',
  [AnalysisStatus.COMPLETED]: 'COMPLETED',
  [AnalysisStatus.ERROR]: 'ERROR',
  [AnalysisStatus.CANCELED]: 'CANCELED',
  [AnalysisStatus.SAVE_ERROR]: 'SAVE_ERROR',
};
